module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalTheme', {
    attrs: {
      "overlay": false,
      "loading": _vm.loading || _vm.parentLoading
    },
    on: {
      "close": _vm.cancel
    }
  }, [_c('template', {
    slot: "main"
  }, [(_vm.profile) ? _c('div', [_c('h1', {
    staticClass: "txtCenter",
    staticStyle: {
      "font-size": "xx-large"
    }
  }, [_vm._v(_vm._s("Edit Profile"))]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('TextInputBloc', {
    attrs: {
      "label": 'name',
      "required": true,
      "max-length": 99
    },
    model: {
      value: (_vm.profile.name),
      callback: function($$v) {
        _vm.profile.name = $$v
      },
      expression: "profile.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Do you want to Edit the rights")]), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon2 pointer",
    on: {
      "click": function($event) {
        _vm.$emit('editRight', this.profileId);
      }
    }
  }, [_vm._v(" " + _vm._s("Edit Rights") + " ")])])])]) : _vm._e()]), _vm._v(" "), (false) ? _c('template', {
    slot: "overlay"
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('client-color-button', {
    on: {
      "click": _vm.save
    }
  }, [_vm._v(" " + _vm._s("Save Profile") + " ")])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b43e738","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/profiles/EditProfile.vue
// module id = 3167
// module chunks = 0